export function collapseString(str: string, beginningChars: number, endingChars: number) {
  // Validate inputs
  if (!str) {
    return '';
  }

  if (typeof beginningChars !== 'number' || typeof endingChars !== 'number') {
    throw new TypeError('beginningChars and endingChars must be numbers');
  }

  if (beginningChars < 0 || endingChars < 0) {
    // Optional: throw an error if negative numbers are not desired
    beginningChars = Math.max(0, beginningChars);
    endingChars = Math.max(0, endingChars);
  }

  if (str.length < beginningChars + endingChars) {
    return str;
  }

  const firstGroup = str.slice(0, beginningChars);
  const lastGroup = str.slice(-endingChars);

  return `${firstGroup}...${lastGroup}`;
}
